export default {
      id: "logo-icon-usage",
      viewBox: "0 0 23 23",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#logo-icon",
      toString: function () {
        return this.url;
      }
    }